/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE = 'ReportsAggsFilterGhostReports';

export const TOGGLE_STATES = {
	ALL: 'ALL',
	GHOST: 'GHOST', // show reports that were generated by scanline
	EXISTING: 'EXISTING', // show reports that were created by users.
};

export const sanitizeToggleState = (toggleState) => {
	return TOGGLE_STATES[toggleState] || TOGGLE_STATES.ALL;
}
